import gql from 'graphql-tag';

export const CREATE_FACEBOOK_IMPORT_REQUEST_MUTATION = gql`
  mutation CreateFacebookImportRequestMutation(
    $articleId: Int!
    $facebookObjectId: ID!
    $optOutFromCampaignReuse: Boolean!
    $optOutFromRunner: Boolean!
  ) {
    createFacebookImportRequest(
      articleId: $articleId
      facebookObjectId: $facebookObjectId
      optOutFromCampaignReuse: $optOutFromCampaignReuse
      optOutFromRunner: $optOutFromRunner
    ) {
      errors
    }
  }
`;
